function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_APP = '/app';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  page404: '/404',
  page500: '/500',
  about: '/about'
};

export const PATH_APP = {
  root: ROOTS_APP,
  dashboard: path(ROOTS_APP, '/dashboard'),
  clientDashboard: path(ROOTS_APP, '/client-dashboard'),
  clients: path(ROOTS_APP, '/clients'),
  cartera: path(ROOTS_APP, '/cartera'),
  carteraSettings: path(ROOTS_APP, '/cartera-settings'),
  countries: path(ROOTS_APP, '/countries'),
  states: path(ROOTS_APP, '/states'),
  cities: path(ROOTS_APP, '/cities'),
  priceLists: path(ROOTS_APP, '/price-lists'),
  products: path(ROOTS_APP, '/products'),
  currencies: path(ROOTS_APP, '/currencies'),
  industries: path(ROOTS_APP, '/industries'),
  workAreas: path(ROOTS_APP, '/work-areas'),
  kanbanPriorities: path(ROOTS_APP, '/kanban-priorities'),
  calendarCategories: path(ROOTS_APP, '/calendar-categories'),
  areaCapacityCalendar: path(ROOTS_APP, '/area-capacity-calendar'),
  areaCalendar: path(ROOTS_APP, '/area-calendar'),
  areaPostIts: path(ROOTS_APP, '/area-post-its'),
  formDesignerForms: path(ROOTS_APP, '/form-designer-forms'),
  processes: path(ROOTS_APP, '/processes'),
  requirementTemplates: path(ROOTS_APP, '/requirement-templates'),
  requirements: path(ROOTS_APP, '/requirements'),
  clientStatuses: path(ROOTS_APP, '/client-statuses'),
  companyProfile: path(ROOTS_APP, '/company-profile'),
  storageConfig:  path(ROOTS_APP, '/storage-config'),
  documentTypes: path(ROOTS_APP, '/document-types'),
  quotes: path(ROOTS_APP, '/quotes'),
  quoteProposalTemplates: path(ROOTS_APP, '/quote-proposal-templates'),
  quoteVariables: path(ROOTS_APP, '/quote-variables'),
  quoteFormulaDefinitions: path(ROOTS_APP, '/quote-formulas'),
  clientQuoteVariables: path(ROOTS_APP, '/client-quote-variables'),
  contractTemplates: path(ROOTS_APP, '/contract-templates'),
  contracts: path(ROOTS_APP, '/contracts'),
  kanban: path(ROOTS_APP, '/kanban'),
  kanbanMyWeek: path(ROOTS_APP, '/kanban-my-week'),
  kanbanCardTemplates: path(ROOTS_APP, '/kanban-card-templates'),
  chatInbox: path(ROOTS_APP, '/chat-inbox'),
  developerReleases: path(ROOTS_APP, '/developer/releases'),
  developerEnpisoApi: path(ROOTS_APP, '/developer/enpiso-api'),
  releaseSystems: path(ROOTS_APP, '/developer/release-systems'),
  releaseSystemForm: path(ROOTS_APP, '/developer/release-systems'),
  infraDashboard: path(ROOTS_APP, '/developer/infra/dashboard'),
  infraServers: path(ROOTS_APP, '/developer/infra/servers'),
  infraServerForm: path(ROOTS_APP, '/developer/infra/servers'),
  infraRuntimeUnits: path(ROOTS_APP, '/developer/infra/runtime-units'),
  infraRuntimeUnitForm: path(ROOTS_APP, '/developer/infra/runtime-units'),
  infraOperations: path(ROOTS_APP, '/developer/infra/operations'),
  infraOperationSchedules: path(ROOTS_APP, '/developer/infra/operation-schedules'),
  infraDeploymentPacks: path(ROOTS_APP, '/developer/infra/deployment-packs'),
  infraDeploymentPackForm: path(ROOTS_APP, '/developer/infra/deployment-packs'),
  infraDeploymentPackVersions: path(ROOTS_APP, '/developer/infra/deployment-pack-versions'),
  infraDeploymentPackVersionForm: path(ROOTS_APP, '/developer/infra/deployment-pack-versions'),
  infraDeploymentPackComponents: path(ROOTS_APP, '/developer/infra/deployment-pack-components'),
  infraDeploymentPackComponentForm: path(ROOTS_APP, '/developer/infra/deployment-pack-components'),
  infraTenantBindings: path(ROOTS_APP, '/developer/infra/tenant-bindings'),
  infraTenantBindingForm: path(ROOTS_APP, '/developer/infra/tenant-bindings'),
  infraAlerts: path(ROOTS_APP, '/developer/infra/alerts'),
  infraSettings: path(ROOTS_APP, '/developer/infra/settings'),
  storageConfig: path(ROOTS_APP, '/developer/storage-config'),
  securityUsers: path(ROOTS_APP, '/security/users'),
  securityRoles: path(ROOTS_APP, '/security/roles'),
  securityChangePassword: path(ROOTS_APP, '/security/change-password'),
  userMailAccount: path(ROOTS_APP, '/mail-account'),
  notificationTemplates: path(ROOTS_APP, '/notification-templates'),
  notificationRules: path(ROOTS_APP, '/notification-rules'),
  notificationDispatches: path(ROOTS_APP, '/notification-dispatches'),
};
